import { useMemo } from 'react';
import { Pagination } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * Integrations Pagination chrome (CT-4996): injects admin-studio copy into the
 * shared `@aimsos/ui` Pagination (which stays English by default).
 */
export function IntegrationsPagination({ rangeLabel, totalItems, labels: labelsProp, ...props }) {
  const { t } = useTranslation('admin-studio');
  const rowsPerPage = labelsProp?.rowsPerPage;
  const itemsOverride = labelsProp?.items;
  const previousPage = labelsProp?.previousPage;
  const nextPage = labelsProp?.nextPage;

  const labels = useMemo(
    () => ({
      rowsPerPage: rowsPerPage ?? t('common.pagination.rowsPerPage'),
      items:
        itemsOverride ??
        t('common.pagination.items', { range: rangeLabel ?? '', count: totalItems ?? 0 }),
      previousPage: previousPage ?? t('common.pagination.previous'),
      nextPage: nextPage ?? t('common.pagination.next'),
    }),
    [t, rangeLabel, totalItems, rowsPerPage, itemsOverride, previousPage, nextPage],
  );

  return (
    <Pagination rangeLabel={rangeLabel} totalItems={totalItems} labels={labels} {...props} />
  );
}
